import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import BattleParticipantRow from '@/components/Battle/BattleParticipantRow.vue'
import BKInput from '@/components/AppShared/BKInput.vue'
import { BKConfirmationDialog } from '@/shared/ui/modals'
import { mdiMagnify } from '@mdi/js'
import { useThrottleFn } from '@vueuse/core'
import api from '@/api'
import BattleWaitList from '@/components/BattleWaitList.vue'
import { ConfirmationDialog } from '@/types/dialogs'
import { eventApi, IEvent } from '@/enitites/event'
import { DownloadCSVButton } from '@/features/csv'
import { BattleDB, BattleParticipant } from '@/enitites/battle'
import store from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'BattleParticipants',
  props: {
    event: null,
    battle: null
  },
  emits: ["update:event", "reload:battle"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:event', updatedEvent: IEvent): void
  (e: 'reload:battle'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  event: IEvent
  battle: BattleDB<BattleParticipant>
};





const dancersSearch = ref('')
const loading = ref(false)
const confirmationDialog = ref<ConfirmationDialog>({
  isShow: false,
  title: '',
  subtitle: '',
  confirmText: '',
  confirm: undefined,
})

const totalParticipants = computed(() =>
  props.battle.participants.filter((dancer) =>
    dancer.dancerName.toLowerCase().includes(dancersSearch.value.toLowerCase())
  )
)

const getUserDB = computed(() => store.getters.getUserDB)

const waitList = computed(() =>
  props.battle.waitList.filter((dancer) => dancer.dancerName.toLowerCase().includes(dancersSearch.value.toLowerCase()))
)

const participantsCheckedIn = computed(() =>
  props.battle.participants.reduce((acc, dancer) => (dancer.checkedIn ? acc + 1 : acc), 0)
)

const isUserAdmin = computed(() => {
  return (
    props.event.staff.admins.some((admin) => admin.id === getUserDB.value.id) ||
    props.event.staff.hosts.some((host) => host.id === getUserDB.value.id) ||
    props.event.staff.organizer.id === getUserDB.value.id
  )
})

const battleLimitText = computed(() => {
  if (props.battle.participationCapType === 'none') return ''
  return props.battle.participationCapType === 'checkIn'
    ? `Check-in cap: ${props.battle.limit}`
    : `Registration cap: ${props.battle.limit}`
})

function getIsParticipantHighlighted(participant: BattleParticipant) {
  return participant.id === props.event.id
}

async function checkInParticipant(participant: BattleParticipant) {
  loading.value = true

  const updatedEvent = await eventApi.checkInUser(props.event.id, participant.id)
  if (updatedEvent) emit('update:event', updatedEvent)
  emit('reload:battle')

  loading.value = false
}

const throttledCheckInParticipant = useThrottleFn(
  (participant: BattleParticipant) => checkInParticipant(participant),
  5000
)

async function unCheckInParticipant(participant: BattleParticipant) {
  loading.value = true

  const data = await api.admin.uncheckInDancer(props.event.id, participant.id)
  if (data) emit('update:event', data)
  emit('reload:battle')

  loading.value = false
}

async function unregisterParticipant(participant: BattleParticipant) {
  loading.value = true

  const data = await api.admin.unregisterDancer(props.battle.id, participant.id)
  if (data) emit('reload:battle')

  loading.value = false
}

function showUnregisterConfirmationDialog(participant: BattleParticipant) {
  confirmationDialog.value = {
    isShow: true,
    title: 'Unregister',
    subtitle: `Are you sure you want to unregister ${participant.dancerName} from Breaking?`,
    confirmText: 'Unregister',
    confirm: () => {
      unregisterParticipant(participant)
      confirmationDialog.value.isShow = false
    },
  }
}

function showUnCheckInConfirmationDialog(participant: BattleParticipant) {
  confirmationDialog.value = {
    isShow: true,
    title: 'Uncheck',
    subtitle: `Are you sure you want to uncheck ${participant.dancerName} from Breaking?`,
    confirmText: 'Uncheck',
    confirm: () => {
      unCheckInParticipant(participant)
      confirmationDialog.value.isShow = false
    },
  }
}

return { __sfc: true,props, emit, dancersSearch, loading, confirmationDialog, totalParticipants, getUserDB, waitList, participantsCheckedIn, isUserAdmin, battleLimitText, getIsParticipantHighlighted, checkInParticipant, throttledCheckInParticipant, unCheckInParticipant, unregisterParticipant, showUnregisterConfirmationDialog, showUnCheckInConfirmationDialog, BattleParticipantRow, BKInput, BKConfirmationDialog, mdiMagnify, BattleWaitList, DownloadCSVButton }
}

})